const DEFAULT_LANDING_PATH = '/dashboard';

export const loginLandingPath = (appState?: { returnTo?: string }) =>
  appState?.returnTo ?? DEFAULT_LANDING_PATH;
